<mat-expansion-panel class="preview-content" (opened)="openedPanel()">
    <mat-expansion-panel-header>
        <mat-panel-title
            class="question-title custom-mat-expansion-panel-header {{headerInfo.category==='SELECTED' ? 'selected-card': ''}}">
            <div class="question-header">
                <div class="q-header">
                    <span class="mcq-number">
                        {{headerInfo.title}}({{questionsInfo?.totalQuestions || questionsInfo?.questions?.length || 0}})
                    </span>
                </div>

            </div>
            <div class="question-description">
                <p>{{headerInfo.description}}</p>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>

    <!-- Add filters for Previously Generated Questions section -->
    <app-question-filters *ngIf="showFilters && headerInfo.category === 'PREVIOUSLYGENERATED'"
        [activeTabIndex]="activeTabIndex" [defaultFilters]="defaultFilters" (applyFilters)="onApplyFilters($event)"
        (clearFilters)="onClearFilters()" (search)="onSearchQuestions($event)">
    </app-question-filters>

    <ng-template [ngTemplateOutlet]="questionsListView"></ng-template>

    <!-- Load more button only for Previously Generated section -->
    <div *ngIf="headerInfo.category === 'PREVIOUSLYGENERATED' && hasMoreQuestions()" class="load-more-container">
        <button mat-stroked-button color="primary" (click)="onLoadMore()" [disabled]="questionsInfo.isLoadingMore">
            <mat-progress-spinner *ngIf="questionsInfo.isLoadingMore" mode="indeterminate" diameter="18"
                strokeWidth="3"></mat-progress-spinner>
            <span *ngIf="!questionsInfo.isLoadingMore">Load more</span>
        </button>
    </div>
</mat-expansion-panel>
<ng-template #questionsListView>
    <app-mcqs-list [mcqsInfo]="questionsInfo" *ngIf="questionsInfo.type === 'MULTIPLE_CHOICE'"
        (selectedMulChoiceQuestion)="selectedMulChoiceQuestion($event)" (removeSelectedMCQ)="removeSelectedMCQ($event)">
    </app-mcqs-list>
    <app-oeqs-list [oeqsInfo]="questionsInfo" *ngIf="questionsInfo.type === 'OPEN_ENDED'"
        (selectedOEQ)="selectedOEQ($event)" (removeSelectedOEQ)="removeSelectedOEQ($event)">
    </app-oeqs-list>
    <app-cqs-list [cqsInfo]="questionsInfo" [fromView]="'list-' + headerInfo.category"
        *ngIf="questionsInfo.type === 'CODING'" (selectedCQ)="selectedCQ($event)"
        (removeSelectedCQ)="removeSelectedCQ($event)">
    </app-cqs-list>
</ng-template>